import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
// import Contactus from "./Contact";
import Domainpage from "./Dapa";
// import Seoinspect from "./Seoinspect";
import { Link } from "react-router-dom";
import Trialcards from "./Trial";
import Nav from "./Navbar";
import Main from "./Main";
import Footer from "./Footer";
import { FaCheck } from "react-icons/fa";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import ChatWidget from "./ChatBot";
import Ai from "./Ai";
// import Sitefaq from "./Sitefaq";
import Topconnection from "./Topconnection";
import LogoSlider from "./logopartner";
import Testimonials from "./Testonomial";
import { Helmet } from "react-helmet";
import { basicauth } from "../Utils/Credentials";
const First = () => {


  return (
    <div>
      <Helmet>
      <title>Track, Analyze &amp; Grow Digitally with SeoBix</title>
        <meta
          name="title"
          content="Track, Analyze &amp; Grow Digitally with SeoBix"
        />
        <meta
          name="description"
          content="SeoBix is a comprehensive SEO platform designed to help you with On-Page SEO, analyze off-page performance, and enhance your website's search visibility."
        />
        <meta name="keywords" content="SEO, SeoBix, On-Page SEO, Off-Page SEO, SEO tool, website optimization, digital growth" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="SeoBix Team" />
        <link rel="canonical" href="https://seobix.com/" />

        {/* 🔹 Open Graph (Facebook, LinkedIn, WhatsApp) */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://seobix.com/" />
        <meta
          property="og:title"
          content="SeoBix | A Powerful Off-Page &amp; On Page SEO Tool"
        />
        <meta
          property="og:description"
          content="Boost your website performance with SeoBix. Analyze on-page and off-page SEO, and uncover insights to grow your search rankings — all in one platform."
        />
        <meta
          property="og:image"
          content="https://seobix.com/Images/top3.png"
        />

        {/* 🔹 Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://seobix.com/" />
        <meta
          name="twitter:title"
          content="Track, Analyze &amp; Grow Digitally with SeoBix"
        />
        <meta
          name="twitter:description"
          content="SeoBix is your complete SEO platform — optimize on-page SEO, track off-page performance, and grow your website rankings."
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/api/post/media/3.png"
        />

        {/* 🔹 Favicon */}
        <link rel="icon" href="https://seobix.com/favicon.ico" />
        <link rel="apple-touch-icon" href="https://seobix.com/logo192.png" />

      </Helmet>
      <Nav />
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        <Main />

        <Trialcards />
        <div
          className="  p-4 "
          style={{
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            marginTop: "7rem",
          }}
        >
          <h2
            style={{ color: "#0A3981" }}
            className="d-flex justify-content-center pt-5"
          >
            <b> Check Your Domain Authority and Age Instantly</b>
          </h2>
          <Domainpage />
        </div>
        <Row
          className="d-flex justify-content-center  "
          style={{
            marginTop: "5rem",
          }}
        >
          <Col md={10}>
            <h1
              style={{
                // fontFamily: "'Playfair Display', serif",
                fontSize: "2.5rem",
              }}
              className="mt-2 mb-3 text-center"
            >
              <b>Plans & Pricing</b>
            </h1>
            <div className="text-center my-4">
              <h4
                className="font-weight-bold mb-4"
                style={{ color: "#441752" }}
              >
                🚀 Improve Your Rankings —{" "}
                <span style={{ color: "#FC4100" }}>Try Our Service Free for 3 Months!</span>,
                Limited Time Only!
              </h4>
              <Link
                style={{ textDecoration: "none" }}
                onClick={() =>
                  window.open("https://dashboard.seobix.com/", "_blank")
                }
              >
                <span
                  style={{
                    color: "#fff",
                    fontWeight: 500,
                    cursor: "pointer",
                    padding: "7px 12px",
                    border: "1px solid #007bff",
                    backgroundColor: "#007bff",
                    borderRadius: "6px",
                    fontSize: ".9rem",
                    textDecoration: "none",
                  }}
                >
                  Get Started For Free
                </span>
              </Link>
            </div>

            <Pricingcard />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <Topconnection />
          </Col>
        </Row>

        <Ai />
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <LogoSlider />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-3 mb-2  mx-1">
          <Col md={10}>
            <Testimonials />
          </Col>
        </Row>
       
       
        {/* <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <Sitefaq />
          </Col>
        </Row> */}
        {/* <Contactus /> */}

        <div
          data-section="Footer"
          className=" p-0 "
          style={{
            overflow: "hidden",
            background:
              "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
            marginTop: "6rem",
          }}
        >
          <Footer />
        </div>
      </Container>
      {/* <ChatWidget /> */}
    </div>
  );
};

const toNumber = (val) => {
  if (val == null) return 0;
  if (typeof val === "number") return val;
  if (typeof val === "string") {
    const cleaned = val.replace(/[^0-9.]/g, "");
    const parsed = parseFloat(cleaned);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

const formatMoney = (amount, currencyCode) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 2,
  }).format(amount);

const Pricingcard = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState("USD");
  const [billingCycle, setBillingCycle] = useState("monthly"); // 👈 NEW
  const USD_TO_INR = 87;


  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  const GetPricingPlans = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Setting/GetPricingPlans`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );
  
      if (!response.ok) throw new Error("Failed to fetch SEO data.");
  
      const data = await response.json();
  
      if (data.status === "0" && data.data) {
        const sortedPlans = [...data.data].sort((a, b) => {
          if (a.identity === "4") return -1;
          if (b.identity === "4") return 1;
          return parseInt(a.identity) - parseInt(b.identity);
        });
  
        const formattedPlans = sortedPlans.map((plan) => ({
          name: plan.plan_name,
          priceUSD: toNumber(plan.amount),
          duration: plan.duration, 
          description: plan.desc1,
          features1: plan.features1,
          features2: plan.features2,
          features3: plan.features3,
          features4: plan.features4,
          heading: plan.heading,
          desc2: plan.desc2,
          features: Array.isArray(plan.data)
            ? plan.data.map((feature) => ({
                text: feature.description,
                video: feature.video_url || null,
              }))
            : [],
          buttonText: "Start Now",
        }));
  
        setPlans(formattedPlans);
      } else {
        setPlans([]);
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
      setPlans([]);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    GetPricingPlans();
  }, []);
  return (
    <>
      {loading ? (
        <div className="text-center my-5">
          <img src={require("../Images/loader.gif")} alt="seobix" />
        </div>
      ) : (
        <>
          {/* Switchers */}
          <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
            {/* Currency Switcher */}
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold">USD</span>
              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="currencySwitch"
                  checked={currency === "INR"}
                  onChange={(e) =>
                    setCurrency(e.target.checked ? "INR" : "USD")
                  }
                />
                <label className="form-check-label" htmlFor="currencySwitch">
                  {currency}
                </label>
              </div>
              <span className="fw-semibold">INR</span>
            </div>

            {/* Billing Cycle Switcher */}
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold">Monthly</span>
              <div className="form-check form-switch m-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="billingSwitch"
                  checked={billingCycle === "yearly"}
                  onChange={(e) =>
                    setBillingCycle(e.target.checked ? "yearly" : "monthly")
                  }
                />
                <label className="form-check-label" htmlFor="billingSwitch">
                  {billingCycle === "yearly" ? "Yearly" : "Monthly"}
                </label>
              </div>
              <span className="fw-semibold">Yearly</span>
            </div>
          </div>

          {/* Pricing Cards */}
          <Row className="justify-content-center mx-1">
            {plans.map((plan, index) => {
              let base = plan.priceUSD; // numeric

              // 💡 Apply yearly multiplier (12x) if yearly selected
              if (billingCycle === "yearly") {
                base = base * 12;
              }

              const amount = currency === "USD" ? base : base * USD_TO_INR;
              const displayPrice = formatMoney(amount, currency);

              return (
                <Col key={index} md={6} lg={3} className="mb-4">
                  <Card className="shadow-sm h-100">
                    <Card.Body className="p-3">
                      <h5 className="mb-1">
                        <b>{plan.name}</b>
                      </h5>
                      <h3>
                        <b>{displayPrice}</b>/
                        <span style={{ fontSize: "1rem" }}>
                          {billingCycle === "yearly" ? "year" : plan.duration}
                        </span>
                      </h3>
                      <Link
                        onClick={() =>
                          window.open("https://dashboard.seobix.com/", "_blank")
                        }
                        style={{ textDecoration: "none", color: "#fff" }}
                      >
                        <Button className="mt-2 mb-2" style={{ width: "100%" }}>
                          {plan.buttonText}
                        </Button>
                      </Link>

                      <p className="text-muted mb-2 mt-3">
                        <b>{plan.description}</b>
                      </p>

                      {plan.features1 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features1}
                        </p>
                      )}
                      {plan.features2 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features2}
                        </p>
                      )}
                      {plan.features3 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features3}
                        </p>
                      )}
                      {plan.features4 && (
                        <p>
                          <FaCheck style={{ color: "green" }} /> &nbsp;&nbsp;
                          {plan.features4}
                        </p>
                      )}

                      {plan.heading && (
                        <h6>
                          <b>{plan.heading}</b>
                        </h6>
                      )}
                      {plan.desc2 && (
                        <p
                          className="text-muted mb-2 mt-3"
                          style={{ fontWeight: "500" }}
                        >
                          {plan.desc2}
                        </p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </>
  );
};

export default First;
